import config from '@nn-design-system/config/web';
import { getBorderRadius as getAliasBorderRadius, getBorderWidth as getAliasBorderWidth, getBorderStyle as getAliasBorderStyle, getOutlineWidth as getAliasOutlineWidth, getOutlineOffset as getAliasOutlineOffset, getOutlineStyle as getAliasOutlineStyle, } from './borders.alias';
import Transformer from '../transformations/web';
export function getBorderRadius() {
    return getAliasBorderRadius(new Transformer(), config);
}
export function getBorderWidth() {
    return getAliasBorderWidth(new Transformer(), config);
}
export function getBorderStyle() {
    return getAliasBorderStyle(new Transformer(), config);
}
export function getOutlineWidth() {
    return getAliasOutlineWidth(new Transformer(), config);
}
export function getOutlineOffset() {
    return getAliasOutlineOffset(new Transformer(), config);
}
export function getOutlineStyle() {
    return getAliasOutlineStyle(new Transformer(), config);
}
